/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Move_TitleInputs */

const en_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Items`)
};

const fr_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer des elements`)
};

const de_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegenstände verschieben`)
};

const it_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta gli elementi`)
};

const ru_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместить предметы`)
};

const es_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover elementos`)
};

const zh_cn2_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移动物品`)
};

const ja_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムを移動する`)
};

const hi_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वस्तुओं को स्थानांतरित करें`)
};

const pt_pt2_explorer_thumbnail_move_title = /** @type {(inputs: Explorer_Thumbnail_Move_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover itens`)
};

/**
* | output |
* | --- |
* | "Move Items" |
*
* @param {Explorer_Thumbnail_Move_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_move_title = /** @type {((inputs?: Explorer_Thumbnail_Move_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Move_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_move_title(inputs)
	if (locale === "de") return de_explorer_thumbnail_move_title(inputs)
	if (locale === "it") return it_explorer_thumbnail_move_title(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_move_title(inputs)
	if (locale === "es") return es_explorer_thumbnail_move_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_move_title(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_move_title(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_move_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_move_title(inputs)
	return en_explorer_thumbnail_move_title(inputs)
});